module.exports = __webpack_public_path__ + "img/Premium Sleep01.00ccae3b.png";